import { render, staticRenderFns } from "./GraficoChat.vue?vue&type=template&id=6f393066&scoped=true&"
import script from "./GraficoChat.vue?vue&type=script&lang=js&"
export * from "./GraficoChat.vue?vue&type=script&lang=js&"
import style0 from "./GraficoChat.vue?vue&type=style&index=0&id=6f393066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f393066",
  null
  
)

export default component.exports